export default [
  {
    path: '/payment-adjustments',
    name: 'payment-adjustment',
    meta: { requiresAuth: true },
    component: () => import('@/pages/payment-adjustment/index.vue')
  },
  {
    path: '/payment-adjustments/create',
    name: 'payment-adjustment-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/payment-adjustment/create.vue')
  },
  {
    path: '/payment-adjustments/:id/edit',
    name: 'payment-adjustment-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/payment-adjustment/edit.vue')
  }
]
